var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconExamAreaMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2B7ABC",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 488 488",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.9,666.06c0-0.1-0.1-0.3-0.1-0.4c0-0.2-0.1-0.3-0.1-0.5c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.2-0.1-0.3-0.2-0.5 c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.3-0.2-0.5-0.4-0.8c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.1-0.1-0.2-0.2-0.3 c-0.1-0.1-0.1-0.2-0.2-0.3l-90-117.4l-0.1-0.1c-0.2-0.2-0.3-0.4-0.5-0.6c-0.1-0.1-0.1-0.2-0.2-0.2c-0.2-0.3-0.5-0.5-0.8-0.7 c0,0,0,0-0.1-0.1c-0.3-0.2-0.5-0.4-0.8-0.6c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.3-0.7-0.4c-0.1,0-0.2-0.1-0.3-0.1 c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.3-0.1-0.5-0.1-0.8-0.1 c-0.1,0-0.2,0-0.3,0c-0.4,0-0.7-0.1-1.1-0.1H49c-5.5,0-10,4.5-10,10v468c0,5.5,4.5,10,10,10h390c5.5,0,10-4.5,10-10v-350.6 c0-0.2,0-0.5,0-0.8v0c0-0.1,0-0.2,0-0.3C449,666.46,448.9,666.26,448.9,666.06z M418.7,657.86h-59.5l-0.2-77.8L418.7,657.86z  M429,1008.46H59v-448h280l0.2,107.4c0,5.5,4.5,10,10,10H429V1008.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.3,723.46c0,5.5,4.5,10,10,10h266.2c5.5,0,10-4.5,10-10s-4.5-10-10-10H111.3C105.8,713.46,101.3,717.96,101.3,723.46 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,672.46h173.9h0c5.5,0,9.9-4.5,9.9-10s-4.5-10-10-10H111.3c-5.5,0-10,4.5-10,10S105.8,672.46,111.3,672.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,794.46h266.2c5.5,0,10-4.5,10-10s-4.5-10-10-10H111.3c-5.5,0-10,4.5-10,10S105.8,794.46,111.3,794.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,855.46c5.5,0,9.9-4.5,9.9-10s-4.5-10-10-10H111.3c-5.5,0-10,4.5-10,10s4.5,10,10,10H285.2L285.2,855.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.9,868.26l-84.2,74.4l-24.3-32.5c-3.3-4.4-9.6-5.3-14-2c-4.4,3.3-5.3,9.6-2,14l30.8,41.2c1.7,2.3,4.2,3.7,7,4 c0.3,0.1,0.7,0.1,1,0.1l0,0c2.4,0,4.7-0.9,6.6-2.6l92.3-81.6c4.2-3.6,4.6-10,0.9-14.1C381.4,864.96,375,864.56,370.9,868.26z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconExamAreaMobile);
export default __webpack_public_path__ + "static/media/common_icon_exam_area_mobile.0b5c886efae7f09490c1edd0a53f2923.svg";
export { ForwardRef as ReactComponent };